var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20106 0H14.8997L23.9672 9.45128V27.8341C23.9672 30.1369 22.1041 32 19.8092 32H4.20106C1.89822 32 0.0351563 30.1369 0.0351563 27.8341V4.1659C0.0351158 1.86306 1.89818 0 4.20106 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8906 0V9.37931H23.9661L14.8906 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 23.8763V18.0312H7.15083C7.76652 18.0312 8.25429 18.1992 8.6221 18.543C8.98991 18.8788 9.17384 19.3346 9.17384 19.9023C9.17384 20.47 8.98991 20.9258 8.6221 21.2616C8.25429 21.6055 7.76652 21.7734 7.15083 21.7734H6.15932V23.8763H4.66406ZM6.15932 20.502H6.98291C7.20679 20.502 7.3827 20.4541 7.50267 20.3421C7.62259 20.2382 7.68659 20.0942 7.68659 19.9024C7.68659 19.7105 7.62263 19.5665 7.50267 19.4626C7.38274 19.3506 7.20683 19.3027 6.98291 19.3027H6.15932V20.502ZM9.7895 23.8763V18.0312H11.8605C12.2683 18.0312 12.6521 18.0872 13.0119 18.2072C13.3717 18.3271 13.6995 18.495 13.9874 18.7269C14.2753 18.9508 14.5071 19.2546 14.675 19.6385C14.835 20.0223 14.9229 20.4621 14.9229 20.9578C14.9229 21.4456 14.835 21.8853 14.675 22.2691C14.5071 22.6529 14.2753 22.9568 13.9874 23.1807C13.6995 23.4125 13.3717 23.5804 13.0119 23.7004C12.6521 23.8203 12.2683 23.8763 11.8605 23.8763H9.7895ZM11.2528 22.605H11.6845C11.9164 22.605 12.1323 22.581 12.3322 22.525C12.5241 22.4691 12.708 22.3811 12.884 22.2612C13.0519 22.1412 13.1878 21.9733 13.2837 21.7494C13.3797 21.5255 13.4277 21.2616 13.4277 20.9578C13.4277 20.6459 13.3797 20.3821 13.2837 20.1582C13.1878 19.9343 13.0519 19.7664 12.884 19.6465C12.708 19.5265 12.5241 19.4386 12.3322 19.3826C12.1323 19.3266 11.9164 19.3026 11.6845 19.3026H11.2528V22.605ZM15.6746 23.8763V18.0312H19.8325V19.3026H17.1698V20.2381H19.2967V21.5015H17.1698V23.8763H15.6746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.d807257d6c7751ef2b3428ba4064a7e8.svg";
export { ForwardRef as ReactComponent };